import { render, staticRenderFns } from "./StudentRDAComponent.vue?vue&type=template&id=a169e9de&scoped=true"
import script from "./StudentRDAComponent.vue?vue&type=script&lang=js"
export * from "./StudentRDAComponent.vue?vue&type=script&lang=js"
import style0 from "./StudentRDAComponent.vue?vue&type=style&index=0&id=a169e9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a169e9de",
  null
  
)

export default component.exports